import React, { useEffect } from 'react';
import { Container } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import '../Features.css';

const Blur = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.getElementById('home').classList.add('featureContent');
    return () => {
      document.getElementById('home').classList.remove('featureContent');
    };
  });
  useEffect(() => {
    setTimeout(() => {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }, 100);
  }, []);
  return (
    <Container className="featurePages blurFeature">
      <div className="header">
        <div className="headerContent">
          <h2 className="title">{t('contents:blurTitle1')}</h2>
          <p className="text">
            {t('contents:blurParagraph1')}
            <br />
            {t('contents:blurParagraph2')}
          </p>
        </div>
        <img src={require('../../../assets/images/features/pages/blur/blur_01.png')} />
      </div>
      <div className="content">
        <div className="container">
          <div className="section section01">
            <div className="textBox">
              <p>
                {t('contents:blurParagraph3')}
                <br />
                <br />
              </p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/blur/Blur-asset-4.png')} />
            </div>
          </div>
          <div className="section section02">
            <div className="textBox">
              <h2 className="title">{t('contents:blurTitle2')}</h2>
              <p>
                {t('contents:blurParagraph4')}
                <br />
                {t('contents:blurParagraph5')}
                <br />
                {t('contents:blurParagraph6')}
              </p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/blur/Blur-asset-1.png')} />
            </div>
          </div>
          <div className="section section03">
            <div className="textBox">
              <h2 className="title">{t('contents:blurTitle3')}</h2>
              <p>
                {t('contents:blurParagraph7')}
                <br />
                {t('contents:blurParagraph8')}
                <br />
                {t('contents:blurParagraph9')}
              </p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/blur/Blur-asset-3.png')} />
            </div>
          </div>
          <div className="section section04">
            <div className="textBox">
              <h2 className="title">{t('contents:blurTitle4')}</h2>
              <p>
                {t('contents:blurParagraph10')}
                <br />
                {t('contents:blurParagraph11')}
              </p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/blur/vibino-feature-blur photo-PIC4.jpg')}
              />
            </div>
          </div>
          <div className="section section05">
            <div className="textBox">
              <h2 className="title">{t('contents:blurTitle5')}</h2>
              <p>{t('contents:blurParagraph12')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/blur/Blur-asset-2.png')} />
            </div>
          </div>
          <div className="section section06">
            <div className="textBox">
              <h2 className="title">{t('contents:blurTitle6')}</h2>
              <p>
                {t('contents:blurParagraph13')}
                <br />
                {t('contents:blurParagraph14')}
                <br />
                {t('contents:blurParagraph15')}
                <br />
                {t('contents:blurParagraph16')}
                <br />
                {t('contents:blurParagraph17')}
              </p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/blur/vibino-feature-blur photo-PIC6.jpg')}
              />
            </div>
          </div>
        </div>
        <div className="footer"></div>
      </div>
    </Container>
  );
};

export default Blur;
